import { gql } from "@apollo/client";

export default gql`
  mutation moveUserToCalibrationGroup(
    $complianceProgramId: Int!
    $userId: Int!
    $calibrationGroupId: Int
  ) {
    setUserCalibrationGroup(
      complianceProgramId: $complianceProgramId
      userId: $userId
      calibrationGroupId: $calibrationGroupId
    ) {
      calibrationGroup {
        id
      }
    }
  }
`;
